import Collection from 'lib/Collection';
import Image from 'model/Image';
import config from 'config';

export default Collection.extend({
	model: Image,

	// Chargement des données depuis l'API ou depuis un fichier local
	url: config.url.image,
	file: config.file.image,

	comparator: function( image )
	{
		return image.get('id');
	},

	toString: function() {
		return 'liste des images';
	}
});
